import { motion } from "framer-motion";
import { useT } from "@/i18n";

// Equirectangular projection over the generated dark world map image.
const project = (lat, lng) => {
  const x = ((lng + 180) / 360) * 100;
  const y = ((90 - lat) / 180) * 100;
  return { x, y };
};

export const WorldMap = ({ mapImage, shares, onSelect, selectedId }) => {
  const { t } = useT();
  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-[#D4AF37]/20 shadow-[0_0_60px_rgba(0,0,0,0.6)]"
      data-testid="world-map">
      <div className="relative w-full" style={{ aspectRatio: "1264 / 848" }}>
        {mapImage && (
          <img
            src={mapImage}
            alt="World mood map"
            className="absolute inset-0 w-full h-full object-cover select-none pointer-events-none"
            draggable={false}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050814]/30 via-transparent to-[#050814]/60" />

        {shares.map((s, i) => {
          const { x, y } = project(s.lat ?? 20, s.lng ?? 0);
          const color = s.creature?.color || "#D4AF37";
          const active = selectedId === s.id;
          return (
            <button
              key={s.id}
              onClick={() => onSelect(s)}
              data-testid={`map-orb-${s.id}`}
              className="absolute -translate-x-1/2 -translate-y-1/2 group"
              style={{ left: `${x}%`, top: `${y}%` }}
              title={s.magic?.magic_title}
            >
              <span
                className="block orb-pulse rounded-full"
                style={{
                  width: active ? 18 : 12,
                  height: active ? 18 : 12,
                  background: color,
                  boxShadow: `0 0 12px 4px ${color}, 0 0 24px 8px ${color}55`,
                  animationDelay: `${(i % 8) * 0.25}s`,
                }}
              />
              <span className="absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap rounded-full bg-black/70 px-2 py-0.5 text-[10px] text-[#FDFBF7] opacity-0 backdrop-blur-md transition-opacity group-hover:opacity-100">
                {s.magic?.magic_title || s.mood}
              </span>
            </button>
          );
        })}

        {shares.length === 0 && (
          <div className="absolute inset-0 flex items-center justify-center">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="font-serif text-lg text-[#A3B1C6]"
            >
              {t("map.empty")}
            </motion.p>
          </div>
        )}
      </div>
    </div>
  );
};
